/* SMIRO Portfolio: grid + filters + ring viewer + shortlist.
   Data comes from a JSON script tag rendered by sections/smiro-portfolio-grid.liquid.
   Every ring keeps its real URL: opening one pushes /collections/portfolio/products/<handle>
   so back, share and refresh behave like a normal page. */
(function () {
  'use strict';
  var root = document.querySelector('[data-smpf-grid]');
  var page = document.querySelector('[data-smpf-page]');
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.3 4.6 6.8 4.6c2 0 3.4 1.1 4.2 2.4.8-1.3 2.2-2.4 4.2-2.4 3.5 0 5.4 3.4 4.1 6.7-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var GLYPH = {
    'Oval': '<ellipse cx="8" cy="8" rx="4.8" ry="7"/>', 'Round': '<circle cx="8" cy="8" r="6.5"/>',
    'Cushion': '<rect x="2" y="2" width="12" height="12" rx="4"/>', 'Emerald': '<polygon points="5,1 11,1 14,4 14,12 11,15 5,15 2,12 2,4"/>',
    'Radiant': '<polygon points="5,1.5 11,1.5 14.5,5 14.5,11 11,14.5 5,14.5 1.5,11 1.5,5"/>', 'Pear': '<path d="M8 1 C4.2 6 3 8 3 10.6 A5 5 0 0 0 13 10.6 C13 8 11.8 6 8 1 Z"/>',
    'Marquise': '<path d="M8 1 C12.4 5 12.4 11 8 15 C3.6 11 3.6 5 8 1 Z"/>', 'Dutch Marquise': '<path d="M8 1 C13.2 4.6 13.2 11.4 8 15 C2.8 11.4 2.8 4.6 8 1 Z"/>',
    'Moval': '<path d="M8 1 C12.2 3.4 13 6 13 8 C13 10 12.2 12.6 8 15 C3.8 12.6 3 10 3 8 C3 6 3.8 3.4 8 1 Z"/>', 'Ashoka': '<polygon points="4.5,1.5 11.5,1.5 14.5,5.5 14.5,10.5 11.5,14.5 4.5,14.5 1.5,10.5 1.5,5.5"/>'
  };
  var SHAPE_ORDER = ['Oval', 'Marquise', 'Radiant', 'Emerald', 'Cushion', 'Pear', 'Round', 'Moval', 'Dutch Marquise', 'Ashoka'];
  var DETAILS = [
    ['tulip', 'Tulip basket', /tulip/i], ['halo', 'Hidden halo', /hidden halo/i], ['cathedral', 'Cathedral', /^cathedral/i],
    ['bezel', 'Bezel', /bezel/i], ['claw', 'Claw prongs', /claw/i], ['split', 'Split shank', /split shank/i],
    ['euro', 'Euroshank', /euroshank/i], ['rail', 'Gallery rail', /^gallery rail$/i], ['pave', 'Pavé', /pav/i],
    ['solitaire', 'Solitaire', /solitaire/i], ['engrav', 'Hand engraving', /engrav/i], ['milgrain', 'Milgrain', /milgrain/i],
    ['twotone', 'Two tone', /two tone/i], ['three', 'Three stone', /three stone|toi et moi/i], ['colour', 'Coloured stone', /__never__/]
  ];
  var METALS = [['y14', '14K yellow gold', /14K\s+Yellow/i], ['y18', '18K yellow gold', /18K\s+Yellow/i], ['white', 'White gold', /White/i], ['plat', 'Platinum', /Platinum/i]];
  var SL_KEY = 'smiro_pf_shortlist';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }
  function sized(u, w) { return u.replace(/([?&])width=\d+/, '$1width=' + w); }
  function isRender(im) { return /snapshot/i.test(im.s) || /render/i.test(im.alt || ''); }

  /* ---------- shortlist (shared by grid + ring page) ---------- */
  var saved = {};
  try { (JSON.parse(localStorage.getItem(SL_KEY) || '[]')).forEach(function (h) { saved[h] = true; }); } catch (e) {}
  function persist() { try { localStorage.setItem(SL_KEY, JSON.stringify(Object.keys(saved))); } catch (e) {} }
  function savedList() { return Object.keys(saved); }

  var toastT;
  function toast(msg, up) {
    var t = $('[data-smpf-toast]'); if (!t) return;
    t.textContent = msg; t.classList.toggle('is-up', !!up); t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* Quiz + booking hand-off. The theme binds #open-quiz links at load, so dynamic
     links need this. Shortlist handles ride along as a `rings` param. */
  function armQuiz() {
    var btn = document.getElementById('global-involve-popup'); if (!btn) return null;
    var list = savedList();
    var cur = (btn.getAttribute('data-params') || '').split(',').filter(function (p) { return p && p.indexOf('rings=') !== 0; });
    if (list.length) cur.push('rings=' + list.join('|'));
    if (cur.length) btn.setAttribute('data-params', cur.join(',')); else btn.removeAttribute('data-params');
    return btn;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.smpf a[href="#open-quiz"]') : null;
    if (!a) return;
    e.preventDefault();
    var btn = armQuiz();
    if (window.smpfCloseViewer) window.smpfCloseViewer(true);
    if (btn) btn.click();
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.smpf a[href="#book-call"]') : null;
    if (!a) return;
    try { window.smiroRings = savedList(); } catch (err) {}
    if (window.smpfCloseViewer) window.smpfCloseViewer(true);
    /* the action bar's own document listener opens the drawer */
  });
  function share(title, url) {
    var full = location.origin + url;
    if (navigator.share) { navigator.share({ title: title, url: full }).catch(function () {}); return; }
    if (navigator.clipboard) { navigator.clipboard.writeText(full).then(function () { toast('Link copied'); }, function () { toast(full); }); } else { toast(full); }
  }

  /* ================= RING PAGE (server rendered) ================= */
  if (page) {
    var handle = page.getAttribute('data-handle');
    var heart = $('[data-smpf-heart]', page);
    function paintHeart() { if (heart) heart.setAttribute('aria-pressed', saved[handle] ? 'true' : 'false'); }
    paintHeart();
    if (heart) heart.addEventListener('click', function () {
      if (saved[handle]) { delete saved[handle]; toast('Removed from your shortlist', true); } else { saved[handle] = true; toast('Saved. Your shortlist lives on the portfolio page.', true); }
      persist(); paintHeart();
    });
    var sh = $('[data-smpf-share]', page);
    if (sh) sh.addEventListener('click', function () { share(document.title, location.pathname); });
    var gal = $('[data-smpf-gal]', page), dots = $('[data-smpf-dots]', page);
    if (gal && dots) gal.addEventListener('scroll', function () {
      var k = Math.round(gal.scrollLeft / gal.clientWidth);
      $$('i', dots).forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      var n = $('[data-smpf-nextlink]', page), p = $('[data-smpf-prevlink]', page);
      if (e.key === 'ArrowRight' && n) location.href = n.getAttribute('href');
      if (e.key === 'ArrowLeft' && p && !p.classList.contains('is-off')) location.href = p.getAttribute('href');
    });
    var body = $('[data-smpf-body]', page), sx = 0, sy = 0, st = 0;
    if (body) {
      body.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now(); }, { passive: true });
      body.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Date.now() - st < 600 && Math.abs(dx) > 70 && Math.abs(dy) < 50) {
          var n = $('[data-smpf-nextlink]', page), p = $('[data-smpf-prevlink]', page);
          if (dx < 0 && n) location.href = n.getAttribute('href');
          if (dx > 0 && p && !p.classList.contains('is-off')) location.href = p.getAttribute('href');
        }
      }, { passive: true });
    }
  }

  /* ================= COLLECTION GRID + VIEWER ================= */
  if (!root) return;
  var dataEl = $('[data-smpf-data]', root);
  var RAW = [];
  try { RAW = JSON.parse(dataEl.textContent); } catch (e) { console.warn('smpf: bad data', e); return; }
  var PAGE = parseInt(root.getAttribute('data-page-size'), 10) || 24;
  var COLL_URL = root.getAttribute('data-collection-url') || '/collections/portfolio';

  var RINGS = RAW.map(function (p, i) {
    var r = {};
    r.i = i; r.id = p.id; r.handle = p.handle; r.title = p.title; r.url = p.url; r.pub = p.pub || '';
    r.name = String(p.title || '').replace(/[’'‘]s?\s*Custom Ring$/i, '').replace(/\s*Custom Ring$/i, '').replace(/[’'‘]S$/, '').trim() || p.title;
    r.shape = p.shape || null;
    if (r.shape && /shapre/i.test(r.shape)) r.shape = null;
    r.metal = (p.metal || '').replace(/\s+/g, ' ').trim();
    if (r.shape && p.stone && r.shape.toLowerCase() === String(p.stone).toLowerCase()) r.shape = null;
    r.carat = p.carat != null && p.carat !== '' ? String(p.carat).replace(/\.0+$/, '') : null;
    r.band = p.band || null;
    r.stone = p.stone || 'Diamond';
    r.features = Array.isArray(p.details) ? p.details.slice() : [];
    r.desc = p.desc || '';
    r.story = r.desc ? r.desc.split(/(?<=[.!?])\s+/).map(function (s) { return s.trim(); }).filter(Boolean) : [];
    r.imgs = (p.imgs || []).filter(Boolean).map(function (im) { im.render = isRender(im); return im; });
    var photos = r.imgs.filter(function (im) { return !im.render; });
    r.hero = photos[0] || r.imgs[0] || null;
    r.det = {};
    DETAILS.forEach(function (d) { if (r.features.some(function (f) { return d[2].test(f); })) r.det[d[0]] = true; });
    if (r.stone && !/^diamond$/i.test(r.stone)) r.det.colour = true;
    var mk = null; METALS.forEach(function (m) { if (!mk && m[2].test(r.metal)) mk = m[0]; });
    r.metalKey = mk || 'other';
    r.metalNice = r.metal.replace('Yellow Gold', 'yellow gold').replace('White Gold', 'white gold').replace('Rose Gold', 'rose gold').replace('Platinum', 'platinum');
    r.poss = /s$/i.test(r.name) ? '’' : '’s';
    var gem = (r.stone && !/^diamond$/i.test(r.stone)) ? r.stone.toLowerCase() : null;
    if (gem === 'fancy colour diamond') gem = 'fancy colour diamond';
    var shapeWord = r.shape ? r.shape.toLowerCase() : (gem || 'ring');
    r.caption = r.name + r.poss + ' ' + shapeWord;
    var bits = []; if (r.carat) bits.push(r.carat + ' ct'); if (r.metalNice) bits.push(r.metalNice); if (r.features[0]) bits.push(r.features[0].toLowerCase());
    r.meta = bits.join(' · ');
    r.headline = cap((r.carat ? r.carat + ' ct ' : '') + (r.shape ? r.shape.toLowerCase() : (gem || 'custom ring')) + ((gem && r.shape) ? ' ' + gem : '') + (r.metalNice ? ' in ' + r.metalNice : ''));
    return r;
  }).filter(function (r) { return r.hero; });
  RINGS.sort(function (a, b) { return b.id - a.id; }); /* newest first, matches the collection's CREATED_DESC order the ring page uses */
  RINGS.forEach(function (r, i) { r.i = i; });
  var byHandle = {}; RINGS.forEach(function (r) { byHandle[r.handle] = r; });

  var state = { shape: null, metals: {}, details: {}, shuffle: false, shown: PAGE };
  var order = RINGS.map(function (r) { return r.i; });
  var deck = [];
  function hasFilters() { return !!state.shape || Object.keys(state.metals).length > 0 || Object.keys(state.details).length > 0; }
  function matches(r) {
    if (state.shape && r.shape !== state.shape) return false;
    var mk = Object.keys(state.metals); if (mk.length && !state.metals[r.metalKey]) return false;
    var dk = Object.keys(state.details); for (var i = 0; i < dk.length; i++) if (!r.det[dk[i]]) return false;
    return true;
  }
  function computeDeck() { deck = order.map(function (i) { return RINGS[i]; }).filter(matches); }
  function filterLabel() {
    var parts = [];
    if (state.shape) parts.push(state.shape === 'Dutch Marquise' ? 'Dutch marquise' : state.shape);
    Object.keys(state.metals).forEach(function (k) { METALS.forEach(function (m) { if (m[0] === k) parts.push(m[1]); }); });
    Object.keys(state.details).forEach(function (k) { DETAILS.forEach(function (d) { if (d[0] === k) parts.push(d[1]); }); });
    return parts.join(' · ');
  }
  var lockDepth = 0;
  function lock() { lockDepth++; document.body.classList.add('overflow-hidden'); document.body.classList.add('smpf-locked'); }
  function unlock() { lockDepth = Math.max(0, lockDepth - 1); if (!lockDepth) { document.body.classList.remove('overflow-hidden'); document.body.classList.remove('smpf-locked'); } }

  /* ---------- chips ---------- */
  function chip(label, count, value, on) {
    var b = document.createElement('button'); b.type = 'button'; b.className = 'smpf-chip'; b.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (value !== null) b.setAttribute('data-shape', value);
    var g = value && GLYPH[value] ? '<svg viewBox="0 0 16 16" aria-hidden="true">' + GLYPH[value] + '</svg>' : '';
    b.innerHTML = g + esc(value === 'Dutch Marquise' ? 'Dutch marquise' : label) + ' <span class="smpf-n">' + count + '</span>';
    return b;
  }
  function renderShapes() {
    var counts = {}; RINGS.forEach(function (r) { if (r.shape) counts[r.shape] = (counts[r.shape] || 0) + 1; });
    var row = $('[data-smpf-shapes]', root); row.innerHTML = '';
    row.appendChild(chip('All', RINGS.length, null, !state.shape));
    var seen = {};
    SHAPE_ORDER.forEach(function (s) { if (counts[s]) { row.appendChild(chip(s, counts[s], s, state.shape === s)); seen[s] = true; } });
    Object.keys(counts).sort().forEach(function (s) { if (!seen[s]) row.appendChild(chip(s, counts[s], s, state.shape === s)); });
  }
  $('[data-smpf-shapes]', root).addEventListener('click', function (e) {
    var c = e.target.closest('.smpf-chip'); if (!c) return;
    state.shape = c.hasAttribute('data-shape') ? c.getAttribute('data-shape') : null;
    refresh(true);
  });

  /* ---------- grid ---------- */
  function cardEl(r, idx) {
    var el = document.createElement('article'); el.className = 'smpf-card' + (idx % 7 === 6 ? ' is-wide' : ''); el.setAttribute('data-card', r.handle);
    el.innerHTML = '<a class="smpf-ph" href="' + esc(r.url) + '" data-open="' + esc(r.handle) + '" aria-label="Open ' + esc(r.caption) + '"><img loading="lazy" src="' + esc(sized(r.hero.s, 600)) + '" srcset="' + esc(sized(r.hero.s, 400)) + ' 400w, ' + esc(sized(r.hero.s, 600)) + ' 600w, ' + esc(sized(r.hero.s, 900)) + ' 900w" sizes="(min-width: 1100px) 25vw, (min-width: 768px) 33vw, 50vw" alt="' + esc(r.caption) + ', ' + esc(r.meta) + '"></a>' +
      '<button class="smpf-heart" type="button" data-heart="' + esc(r.handle) + '" aria-pressed="' + (saved[r.handle] ? 'true' : 'false') + '" aria-label="Save ' + esc(r.caption) + '">' + HEART + '</button>' +
      '<div class="smpf-cap"><span class="smpf-cname smpf-ser">' + esc(r.caption) + '</span><span class="smpf-cmeta">' + esc(r.meta) + '</span></div>';
    return el;
  }
  function renderGrid(reset) {
    var grid = $('[data-smpf-cards]', root);
    if (reset) { grid.innerHTML = ''; state.shown = PAGE; }
    var base = grid.children.length;
    var frag = document.createDocumentFragment();
    deck.slice(base, state.shown).forEach(function (r, k) { frag.appendChild(cardEl(r, base + k)); });
    grid.appendChild(frag);
    var shown = grid.children.length;
    $('[data-smpf-count]', root).textContent = deck.length ? ('Showing ' + shown + ' of ' + deck.length) : 'Showing 0 of 0';
    $('[data-smpf-more]', root).hidden = deck.length <= shown;
    $('[data-smpf-moremeta]', root).textContent = deck.length > shown ? (deck.length - shown) + ' more' : '';
    $('[data-smpf-empty]', root).hidden = deck.length > 0;
    renderTags();
  }
  function renderTags() {
    var t = $('[data-smpf-tags]', root); t.innerHTML = '';
    Object.keys(state.metals).forEach(function (k) { METALS.forEach(function (m) { if (m[0] === k) t.appendChild(tagX(m[1], 'metal', k)); }); });
    Object.keys(state.details).forEach(function (k) { DETAILS.forEach(function (d) { if (d[0] === k) t.appendChild(tagX(d[1], 'detail', k)); }); });
    $('[data-smpf-morefilters]', root).classList.toggle('is-on', Object.keys(state.metals).length + Object.keys(state.details).length > 0);
  }
  function tagX(label, kind, key) {
    var b = document.createElement('button'); b.type = 'button'; b.className = 'smpf-tagx'; b.setAttribute('data-untag', kind + ':' + key); b.setAttribute('aria-label', 'Remove ' + label);
    b.innerHTML = esc(label) + X; return b;
  }
  $('[data-smpf-tags]', root).addEventListener('click', function (e) {
    var b = e.target.closest('[data-untag]'); if (!b) return;
    var p = b.getAttribute('data-untag').split(':');
    if (p[0] === 'metal') delete state.metals[p[1]]; else delete state.details[p[1]];
    refresh(true);
  });
  $('[data-smpf-cards]', root).addEventListener('click', function (e) {
    var h = e.target.closest('[data-heart]'); if (h) { toggleSave(byHandle[h.getAttribute('data-heart')]); return; }
    var o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); openRing(byHandle[o.getAttribute('data-open')], true); }
  });
  $('[data-smpf-morebtn]', root).addEventListener('click', function () { state.shown += PAGE; renderGrid(false); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { if (en[0].isIntersecting && !$('[data-smpf-more]', root).hidden) { state.shown += PAGE; renderGrid(false); } }, { rootMargin: '600px 0px' }).observe($('[data-smpf-more]', root));
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-smpf-clear]')) { state.shape = null; state.metals = {}; state.details = {}; refresh(true); syncSheet(); }
  });
  $('[data-smpf-shuffle]', root).addEventListener('click', function () {
    var b = this;
    state.shuffle = !state.shuffle;
    order = RINGS.map(function (r) { return r.i; });
    if (state.shuffle) { for (var i = order.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = order[i]; order[i] = order[j]; order[j] = t; } }
    b.setAttribute('aria-pressed', state.shuffle ? 'true' : 'false');
    b.textContent = state.shuffle ? (b.getAttribute('data-label-on') || 'Shuffled · reset') : (b.getAttribute('data-label') || 'Shuffle');
    b.classList.toggle('is-on', state.shuffle);
    refresh(true);
    if (state.shuffle) toast('Shuffled. Same rings, new order.');
  });
  function refresh(scrollTop) {
    computeDeck(); renderShapes(); renderGrid(true);
    if (scrollTop) {
      var f = $('[data-smpf-filters]', root); var top = parseInt(getComputedStyle(f).top, 10) || 0;
      var y = f.getBoundingClientRect().top + window.pageYOffset - top;
      if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'auto' });
    }
  }

  /* ---------- shortlist ---------- */
  function toggleSave(r) {
    if (!r) return;
    if (saved[r.handle]) { delete saved[r.handle]; toast('Removed from your shortlist', vi >= 0); } else { saved[r.handle] = true; toast('Saved to your shortlist', vi >= 0); }
    persist(); syncHearts();
  }
  function syncHearts() {
    $$('[data-heart]', root).forEach(function (b) { b.setAttribute('aria-pressed', saved[b.getAttribute('data-heart')] ? 'true' : 'false'); });
    var n = savedList().length; $('[data-smpf-shortcount]', root).textContent = n; $('[data-smpf-shortpill]', root).classList.toggle('has', n > 0);
    if (vi >= 0 && deck[vi]) $('[data-smpf-vheart]', root).setAttribute('aria-pressed', saved[deck[vi].handle] ? 'true' : 'false');
  }
  function renderShortlist() {
    var body = $('[data-smpf-slbody]', root); var keys = savedList().filter(function (h) { return byHandle[h]; });
    if (!keys.length) { body.innerHTML = '<p class="smpf-slempty">' + esc(root.getAttribute('data-t-slempty') || 'Nothing saved yet. Tap the heart on any ring you like and it will wait here.') + '</p>'; return; }
    body.innerHTML = '<div class="smpf-slgrid">' + keys.map(function (h) {
      var r = byHandle[h];
      return '<div class="smpf-sl"><button class="smpf-im" type="button" data-slopen="' + esc(h) + '" aria-label="Open ' + esc(r.caption) + '"><img src="' + esc(sized(r.hero.s, 300)) + '" alt="" loading="lazy"></button><button class="smpf-rm" type="button" data-slrm="' + esc(h) + '" aria-label="Remove">' + X + '</button><small>' + esc(r.caption) + '</small></div>';
    }).join('') + '</div>';
  }
  $('[data-smpf-shortpill]', root).addEventListener('click', function () { renderShortlist(); openSheet('[data-smpf-ssheet]'); });
  $('[data-smpf-slbody]', root).addEventListener('click', function (e) {
    var rm = e.target.closest('[data-slrm]'); if (rm) { toggleSave(byHandle[rm.getAttribute('data-slrm')]); renderShortlist(); return; }
    var op = e.target.closest('[data-slopen]'); if (op) { closeSheets(); openRing(byHandle[op.getAttribute('data-slopen')], true); }
  });
  var slshare = $('[data-smpf-slshare]', root);
  if (slshare) slshare.addEventListener('click', function () { share('My SMIRO shortlist', COLL_URL + '?rings=' + savedList().join(',')); });

  /* ---------- sheets ---------- */
  var sheetOpen = false;
  function openSheet(sel) { closeSheets(); $('[data-smpf-backdrop]', root).hidden = false; $(sel, root).hidden = false; $(sel, root).scrollTop = 0; if (!sheetOpen) { sheetOpen = true; lock(); } }
  function closeSheets() { $('[data-smpf-backdrop]', root).hidden = true; $$('.smpf-sheet', root).forEach(function (s) { s.hidden = true; }); if (sheetOpen) { sheetOpen = false; unlock(); } }
  $('[data-smpf-backdrop]', root).addEventListener('click', closeSheets);
  $('[data-smpf-morefilters]', root).addEventListener('click', function () { syncSheet(); openSheet('[data-smpf-fsheet]'); });
  $('[data-smpf-apply]', root).addEventListener('click', function () { closeSheets(); refresh(true); });
  function optBtn(label, count, kind, key, on) {
    return '<button class="smpf-chip" type="button" data-opt="' + kind + ':' + key + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(label) + ' <span class="smpf-n">' + count + '</span></button>';
  }
  function syncSheet() {
    var mc = {}, dc = {};
    RINGS.forEach(function (r) { mc[r.metalKey] = (mc[r.metalKey] || 0) + 1; Object.keys(r.det).forEach(function (k) { dc[k] = (dc[k] || 0) + 1; }); });
    $('[data-smpf-metalopts]', root).innerHTML = METALS.filter(function (m) { return mc[m[0]]; }).map(function (m) { return optBtn(m[1], mc[m[0]], 'metal', m[0], !!state.metals[m[0]]); }).join('');
    $('[data-smpf-detailopts]', root).innerHTML = DETAILS.filter(function (d) { return dc[d[0]]; }).map(function (d) { return optBtn(d[1], dc[d[0]], 'detail', d[0], !!state.details[d[0]]); }).join('');
    computeDeck();
    var ap = $('[data-smpf-apply]', root);
    ap.textContent = deck.length ? ('Show ' + deck.length + (deck.length === 1 ? ' ring' : ' rings')) : (root.getAttribute('data-t-nomatch') || 'No rings match');
    ap.disabled = !deck.length;
  }
  $('[data-smpf-fsheet]', root).addEventListener('click', function (e) {
    var b = e.target.closest('[data-opt]'); if (!b) return;
    var p = b.getAttribute('data-opt').split(':'); var set = p[0] === 'metal' ? state.metals : state.details;
    if (set[p[1]]) delete set[p[1]]; else set[p[1]] = true;
    syncSheet();
  });

  /* ---------- viewer ---------- */
  var vi = -1, pushed = false;
  var viewer = $('[data-smpf-viewer]', root), vscroll = $('[data-smpf-vscroll]', root);
  var CTA1 = root.getAttribute('data-cta1-label') || 'Start a ring like this', CTA1U = root.getAttribute('data-cta1-url') || '/pages/custom-ring-process';
  var CTA2 = root.getAttribute('data-cta2-label') || 'Free Custom Ring Estimate', CTA2U = root.getAttribute('data-cta2-url') || '/collections/rings';
  function deckIndexOf(r) { for (var i = 0; i < deck.length; i++) if (deck[i].i === r.i) return i; return -1; }
  function nextRing() { if (!deck.length) return null; if (vi < deck.length - 1) return deck[vi + 1]; return hasFilters() ? null : deck[0]; }
  function prevRing() { if (!deck.length) return null; return deck[(vi - 1 + deck.length) % deck.length]; }
  function similar(r, n) {
    return RINGS.filter(function (x) { return x.i !== r.i; }).map(function (x) {
      var s = 0; if (x.shape && x.shape === r.shape) s += 3; if (x.metalKey === r.metalKey) s += 1;
      Object.keys(r.det).forEach(function (k) { if (x.det[k]) s += 1; });
      return [s, x];
    }).sort(function (a, b) { return b[0] - a[0]; }).slice(0, n).map(function (p) { return p[1]; });
  }
  function slideImg(im, k, r) {
    return '<img src="' + esc(sized(im.s, 900)) + '" srcset="' + esc(sized(im.s, 600)) + ' 600w, ' + esc(sized(im.s, 900)) + ' 900w, ' + esc(sized(im.s, 1400)) + ' 1400w" sizes="(min-width: 900px) 540px, 100vw" alt="' + esc(r.caption) + ', photo ' + (k + 1) + '"' + (k ? ' loading="lazy"' : '') + '>';
  }
  function ringHTML(r) {
    var photos = r.imgs.filter(function (im) { return !im.render; }), renders = r.imgs.filter(function (im) { return im.render; });
    var ordered = photos.concat(renders);
    var slides = ordered.map(function (im, k) { return '<div class="smpf-slide">' + slideImg(im, k, r) + (im.render ? '<span class="smpf-tag">3D render</span>' : '') + '</div>'; }).join('');
    var dots = ordered.length > 1 ? '<div class="smpf-dots" data-dots>' + ordered.map(function (_, k) { return '<i class="' + (k ? '' : 'is-on') + '"></i>'; }).join('') + '</div>' : '';
    var gem = (r.stone && !/^diamond$/i.test(r.stone)) ? r.stone : '';
    var tiles = [];
    if (r.shape || gem) tiles.push(['Shape', r.shape || gem, r.shape ? (gem || 'diamond') : '']);
    if (r.carat) tiles.push(['Carat', r.carat + ' ct', '']);
    if (r.metal) { var km = (r.metal.match(/\d+K/) || [])[0]; tiles.push(['Metal', km || r.metal, km ? r.metal.replace(/\d+K\s*/, '').toLowerCase() : '']); }
    if (r.band) {
      var m = r.band.match(/^([\d.]+)\s*mm(?:\s+tapering to\s+([\d.]+)\s*mm)?(?:,\s*(.*))?$/i);
      if (m) tiles.push(['Band', m[2] ? (m[1] + ' → ' + m[2] + ' mm') : (m[1] + ' mm'), m[3] ? cap(m[3]) : (m[2] ? 'tapered' : '')]); else tiles.push(['Band', cap(r.band), '']);
    }
    var specs = tiles.length ? '<div class="smpf-specs' + (tiles.length === 3 ? ' n3' : '') + '">' + tiles.map(function (t) { return '<div class="smpf-tile"><small>' + t[0] + '</small><b>' + esc(t[1]) + '</b>' + (t[2] ? '<span>' + esc(t[2]) + '</span>' : '') + '</div>'; }).join('') + '</div>' : '';
    var chips = r.features.slice(0, 6).map(function (f) { return '<button class="smpf-fchip" type="button" data-feat="' + esc(f) + '">' + esc(f) + '</button>'; }).join('');
    var lede = r.story[0] || ''; var rest = r.story.slice(1);
    var details = rest.length ? '<div class="smpf-vsec"><span class="smpf-eyebrow">The details</span><ul class="smpf-vdetails">' + rest.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul></div>' : '';
    var pair = (renders[0] && photos[0]) ? '<div class="smpf-vsec"><span class="smpf-eyebrow">From render to ring</span><div class="smpf-pair"><figure><div class="smpf-im"><img src="' + esc(sized(renders[0].s, 600)) + '" alt="3D render of ' + esc(r.caption) + '" loading="lazy"></div><figcaption><b>How it started</b>The 3D render we approve together.</figcaption></figure><figure><div class="smpf-im"><img src="' + esc(sized(photos[0].s, 600)) + '" alt="' + esc(r.caption) + ', finished" loading="lazy"></div><figcaption><b>How it finished</b>The real ring.</figcaption></figure></div></div>' : '';
    var sims = similar(r, 6).map(function (s) {
      return '<a class="smpf-sim" href="' + esc(s.url) + '" data-open="' + esc(s.handle) + '"><div class="smpf-im"><img src="' + esc(sized(s.hero.s, 300)) + '" alt="' + esc(s.caption) + '" loading="lazy"></div><span class="smpf-ser">' + esc(s.caption) + '</span><small>' + esc(s.meta) + '</small></a>';
    }).join('');
    var nx = nextRing();
    var upnext = nx ? '<button class="smpf-upnext" type="button" data-next><div class="smpf-im"><img src="' + esc(sized(nx.hero.s, 900)) + '" alt="' + esc(nx.caption) + '" loading="lazy"></div><div class="smpf-ux"><div class="smpf-t"><span class="smpf-eyebrow">Up next</span><span class="smpf-ser">' + esc(nx.caption) + '</span><small>' + esc(nx.meta) + '</small></div><span class="smpf-arrow">' + ARROW + '</span></div></button>'
      : '<button class="smpf-upnext" type="button" data-next><div class="smpf-ux"><div class="smpf-t"><span class="smpf-eyebrow">That is every ' + esc(filterLabel().toLowerCase()) + ' ring</span><span class="smpf-ser">Keep going with all ' + RINGS.length + '</span><small>Clears the filter and carries on from here.</small></div><span class="smpf-arrow">' + ARROW + '</span></div></button>';
    return '<div class="smpf-hgal" data-gal>' + slides + '</div>' + dots +
      '<div class="smpf-vbody" data-body>' +
        '<span class="smpf-vname">Our clients</span>' +
        '<h2 class="smpf-vh">' + esc(r.name) + '</h2>' +
        '<p class="smpf-vsub">' + esc(r.headline) + '</p>' + specs +
        (chips ? '<div class="smpf-fchips">' + chips + '</div>' : '') +
        (lede ? '<p class="smpf-vlede smpf-ser">' + esc(lede) + '</p>' : '') + details + pair +
        '<div class="smpf-vcta"><a class="smpf-btn smpf-btn-primary" href="' + esc(CTA1U) + '">' + esc(CTA1) + '</a><a class="smpf-btn smpf-btn-outline" href="' + esc(CTA2U) + '">' + esc(CTA2) + '</a></div>' +
        (sims ? '<div class="smpf-vsec"><span class="smpf-eyebrow">Keep looking</span><div class="smpf-simrow">' + sims + '</div></div>' : '') +
        upnext + '</div>';
  }
  function updateBar() {
    var nx = nextRing(); var nb = $('[data-smpf-vnext]', root);
    if (nx) {
      nb.innerHTML = '<span class="smpf-coin"><img src="' + esc(sized(nx.hero.s, 200)) + '" alt=""></span><span class="smpf-t"><small>Next ring</small><b>' + esc(nx.caption) + '</b></span>' + ARROW;
      nb.setAttribute('aria-label', 'Next ring: ' + nx.caption); nb.setAttribute('data-mode', 'next');
    } else {
      nb.innerHTML = '<span class="smpf-coin all">' + RINGS.length + '</span><span class="smpf-t"><small>You have seen all ' + deck.length + '</small><b>Keep going with every ring</b></span>' + ARROW;
      nb.setAttribute('aria-label', 'Clear filters and keep going'); nb.setAttribute('data-mode', 'all');
    }
    $('[data-smpf-vprev]', root).disabled = deck.length < 2;
    var lab = filterLabel();
    $('[data-smpf-vcount]', root).innerHTML = '<b>' + (vi + 1) + '</b> of ' + deck.length + (lab ? ' · ' + esc(lab) : '');
  }
  function paint(r) {
    vscroll.innerHTML = ringHTML(r); vscroll.scrollTop = 0;
    updateBar(); syncHearts();
    var gal = $('[data-gal]', vscroll), dots = $('[data-dots]', vscroll);
    if (gal && dots) gal.addEventListener('scroll', function () {
      var k = Math.round(gal.scrollLeft / gal.clientWidth);
      $$('i', dots).forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
    }, { passive: true });
    var body = $('[data-body]', vscroll), sx = 0, sy = 0, st = 0;
    body.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now(); }, { passive: true });
    body.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Date.now() - st < 600 && Math.abs(dx) > 70 && Math.abs(dy) < 50) go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
  function openRing(r, push) {
    if (!r) return;
    var di = deckIndexOf(r);
    if (di < 0) { state.shape = null; state.metals = {}; state.details = {}; refresh(false); di = deckIndexOf(r); }
    vi = di;
    var wasHidden = viewer.hidden;
    viewer.hidden = false;
    if (wasHidden) lock();
    $('[data-smpf-shortpill]', root).hidden = true;
    paint(r);
    try {
      if (wasHidden && push) { history.pushState({ smpf: r.handle }, '', r.url); pushed = true; }
      else { history.replaceState({ smpf: r.handle }, '', r.url); }
    } catch (e) {}
    document.title = r.title + ' | SMIRO STUDIO';
    $('[data-smpf-vpanel]', root).focus({ preventScroll: true });
  }
  function hideViewer() {
    if (viewer.hidden) return;
    viewer.hidden = true; unlock(); $('[data-smpf-shortpill]', root).hidden = false; vi = -1; syncHearts();
    document.title = root.getAttribute('data-title') || document.title;
  }
  function closeViewer(silent) {
    if (viewer.hidden) return;
    if (pushed && !silent) { pushed = false; history.back(); return; }
    pushed = false; hideViewer();
    try { history.replaceState(null, '', COLL_URL); } catch (e) {}
  }
  window.smpfCloseViewer = closeViewer;
  window.addEventListener('popstate', function (e) {
    var st = e.state && e.state.smpf;
    if (st && byHandle[st]) { openRing(byHandle[st], false); }
    else if (!viewer.hidden) { pushed = false; hideViewer(); }
  });
  function go(dir) {
    var target = dir > 0 ? nextRing() : prevRing();
    if (!target && dir > 0) {
      var cur = deck[vi]; state.shape = null; state.metals = {}; state.details = {}; refresh(false);
      vi = deckIndexOf(cur); target = nextRing(); toast('Filters cleared. Every ring is in the deck now.', true);
    }
    if (!target) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var swap = function () {
      vi = deckIndexOf(target); paint(target);
      try { history.replaceState({ smpf: target.handle }, '', target.url); } catch (e) {}
      document.title = target.title + ' | SMIRO STUDIO';
      if (reduce) return;
      vscroll.classList.remove('is-anim', 'is-out'); vscroll.classList.add('is-in');
      if (dir < 0) vscroll.style.transform = 'translateX(-28px)';
      void vscroll.offsetWidth;
      vscroll.classList.remove('is-in'); vscroll.classList.add('is-anim'); vscroll.style.transform = '';
      setTimeout(function () { vscroll.classList.remove('is-anim'); }, 260);
    };
    if (reduce) { swap(); return; }
    vscroll.classList.add('is-anim', 'is-out'); if (dir < 0) vscroll.style.transform = 'translateX(28px)';
    setTimeout(swap, 200);
  }
  $('[data-smpf-vnext]', root).addEventListener('click', function () { go(1); });
  $('[data-smpf-vprev]', root).addEventListener('click', function () { go(-1); });
  $('[data-smpf-vback]', root).addEventListener('click', function () { closeViewer(false); });
  $('[data-smpf-vheart]', root).addEventListener('click', function () { if (vi >= 0) toggleSave(deck[vi]); });
  $('[data-smpf-vshare]', root).addEventListener('click', function () { if (vi >= 0) share(deck[vi].title + ' by SMIRO STUDIO', deck[vi].url); });
  vscroll.addEventListener('click', function (e) {
    if (e.target.closest('[data-next]')) { go(1); return; }
    var o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); openRing(byHandle[o.getAttribute('data-open')], false); return; }
    var f = e.target.closest('[data-feat]');
    if (f) {
      var feat = f.getAttribute('data-feat'); var key = null;
      DETAILS.forEach(function (d) { if (!key && d[2].test(feat)) key = d[0]; });
      if (!key) return;
      var cur = deck[vi]; state.details = {}; state.details[key] = true; state.metals = {}; state.shape = null;
      refresh(false); vi = deckIndexOf(cur);
      var lab = ''; DETAILS.forEach(function (d) { if (d[0] === key) lab = d[1]; });
      var top = vscroll.scrollTop; paint(cur); vscroll.scrollTop = top;
      toast('Now browsing ' + deck.length + ' rings with ' + lab.toLowerCase() + '. Next walks through them.', true);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (sheetOpen) { if (e.key === 'Escape') closeSheets(); return; }
    if (viewer.hidden) return;
    if (e.key === 'ArrowRight') go(1); else if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'Escape') closeViewer(false);
  });

  /* ---------- boot ---------- */
  computeDeck(); renderShapes(); renderGrid(true); syncHearts();
  var qs = new URLSearchParams(location.search);
  if (qs.get('rings')) { qs.get('rings').split(',').forEach(function (h) { if (byHandle[h]) saved[h] = true; }); persist(); syncHearts(); renderShortlist(); openSheet('[data-smpf-ssheet]'); }
  if (history.state && history.state.smpf && byHandle[history.state.smpf]) openRing(byHandle[history.state.smpf], false);
})();
